// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__8zu7p","imgContainer":"BlogCard_imgContainer__7LCrR","tag":"BlogCard_tag__yubqq","title":"BlogCard_title__5M85_","date":"BlogCard_date__qd3xd"};